import React from "react";

export default function Arrow(props) {
  return (
    <svg
      focusable="false"
      aria-hidden={true}
      width={34}
      height={54}
      viewBox="0 0 34 54"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.769 27.21L32.13 10.85c2.133-2.133 2.556-5.611.656-7.955a5.759 5.759 0 0 0-8.544-.456L5.179 21.5l-3.09 3.152a3.744 3.744 0 0 0-1.002 1.923l-.03.155a3.362 3.362 0 0 0 .93 2.995L24.241 51.98a5.722 5.722 0 0 0 4.06 1.682c1.61 0 3.223-.67 4.385-2.015 2.004-2.328 1.627-5.892-.545-8.064L15.769 27.21z"
        fill="white"
        fillRule="evenodd"
      />
    </svg>
  );
}
